import React from 'react';
import {Route, Switch,} from 'react-router-dom';
import {NotificationContainer} from 'react-notifications';

import {Login, Profile, Registro} from './common/components/LoginRegister';
import Home from './common/components/Home';
import ProtectedRoute from './ProtectedRoute';
import Examples from './common/components/Examples/Basic';
import NotFound from './common/components/layout/NotFound/NotFound';
import sendRecoverPassword from './common/components/LoginRegister/RecoverPassword/SendRecovery';
import PassRecover from './common/components/LoginRegister/ChangePassword/';

import '../assets/fonts/fonts.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Grids from "./common/components/Examples/Grids";
import Notificaciones from './common/components/Examples/Notificaciones';
import ExampleTabs from './common/components/Examples/Tabs/Tabs';
//Usuarios
import {CrearUsuario, UsuariosList} from './common/components/App/Usuarios'
//Bancos
import {BancoCrear, BancosListar} from './common/components/App/Bancos';
//EMAILS NOTIFICACIONES
import {EmailsCrear, EmailsListar} from './common/components/App/NotifiEmails';
//Propietarios
import {PropietarioCrear, PropietariosListar} from './common/components/App/Propietarios';
//Perfil Finca
import {PerfilCrear, PerfilesFincaList} from './common/components/App/PerfilFincas';
// Transportistas
import { TransportistaSave, TransportistasList } from './common/components/App/Transportistas';
//Vehiculos
import {VehiculoCrear, VehiculosListar} from "./common/components/App/Vehiculos";
//Tipos de vehiculo
import {TiposVehiculoCrear, TiposVehiculoListar} from "./common/components/App/TiposVehiculo";
//Pilotos
import {PilotoCrear, PilotosListar} from "./common/components/App/Pilotos";
// TiposMateriaPrima
import {TipoMateriaPrimaCrear, TiposMateriaPrimaListar} from "./common/components/App/TipoMateriaPrima";
// MateriaPrima
import {MateriaPrimaCrear, MateriaPrimaListar} from "./common/components/App/MateriaPrima";
//Tipos de pago
import {TipoPagoCrear, TiposPagoListar} from "./common/components/App/TipoPago";
// Acopios
import { AcopioSave, AcopiosList } from './common/components/App/Acopios';
//Fincas
import {FincaCrear, FincasListar, FincaVer, FincaBitacoraFletes} from "./common/components/App/Fincas";
//Bodegas
import {BodegaCrear, BodegasTabs, BodegaVer} from "./common/components/App/Bodega";
//Ingresos o Recepciones
import {
    EditarPesoProducto,
    IngresoCrear,
    IngresoPesar,
    IngresosListar,
    IngresoVer,
    IngresoVerBoleta,
    CrearRecepcionesClass,
    ResumenCreacionClass,
} from "./common/components/App/Ingresos";
import { BoletaSalida } from './common/components/App/Impresiones';
//Tanques
import {TanquesListar} from "./common/components/App/Produccion/Tanques";
//Pilas
import {PilaSalida, PilasList, PilaVer} from "./common/components/App/Produccion/Pilas";
//Almacenes
import {AlmacenesList, AlmacenSalida, AlmacenVer} from "./common/components/App/Produccion/Almacenes";

//Análisis de bodegas
import {
    AnalisisPilasListar, AnalisisPilasVer, AnalisisPilasEditar, AnalisisPilasPendienteValidacion, AnalisisPilasHistorico,
} from "./common/components/App/LaboratorioPilasTanques";

//Laboratorio de LÁTEX y SÓLIDOS
import {
    LaboratorioLatexListar, LaboratorioLatexEditar, PendientesLatexValidar, AnalisisLatexVer, HistoricoAnalisisLatex
} from "./common/components/App/LaboratorioLatex";
import {
    LaboratorioSolidoEditar, AnalisisSolidoVer, LaboratorioSolidoListar, PendientesSolidoValidar, HistoricoAnalisisSolido, LaboratorioSolidoDRC
} from "./common/components/App/LaboratorioSolidos";
//Liquidaciones
import {LiquidacionesCrear, LiquidacionesListar, LiquidacionesVer, BoletaLiquidacion} from "./common/components/App/Liquidaciones";
//Compras
import {ComprasCrear, ComprasListar} from "./common/components/App/Compras";
// Contaminantes
import {ContaminanteCrear, ContaminantesListar} from "./common/components/App/Contaminantes";
// Roles
import {RolesCrear, RolesListar} from "./common/components/App/Roles"
// Traslados
import {
    CreacionTraslado,
    SeleccionRecepciones,
    PesajeTraslado,
    RecepcionTraslado,
    EnvioTraslados,
    RecepcionTraslados,
    ReporteTraslados,
    BoletaTraslado,
} from "./common/components/App/Traslados";
// InventariosAlmacen
import {
    HistoricoInventarios,
    AlmacenesInventario,
    GestionAlmacen,
    IngresosAlmacen,
    InventarioInicial,
    ReporteInventarios,
    CreacionCierreMensual,
    DetalleCierreMensual,
    InventarioOtrosAcopios,
    SobranteAlmacenConsulta,
} from "./common/components/App/InventariosAlmacen";

// Traslados de almacén
import {
    CreacionTrasladoAlmacen,
} from "./common/components/App/TrasladosAlmacen";

// Laboratorio de producción
import { 
    PendientesAnalisis, 
    AnalisisDRC,
    ValidacionDRC,
    DetalleDRC,
    PendientesValidacion, 
    HistorialSolicitudes,
} from "./common/components/App/LaboratorioProduccion";

// Produccion V2
import {
    Producciones,
    CreacionProduccion,
    EdicionProduccion,
    TurnosProduccion,
    Tancadas,
    CargasTancada,
    ProduccionReportada,
    Paletizaciones,
    CreacionPaletizacion,
    DetallePaletizacion,
    CierreTurno,
    DetalleTurnoFinalizado,
    MigaDesecho,
    BultosSkim,
    ReportesProduccion,
    CierresMensualesProduccion,
    RegistroCierreMensualProduccion,
    DetalleCierreMensualProduccion,
    TancadasTurno,
} from "./common/components/App/ProduccionV2";
import { conCorrelativoInicial } from "./common/components/App/ProduccionV2/components/BloqueoCorrelativoInicial/BloqueoCorrelativoInicial";
import { conCorrelativoTancadas } from "./common/components/App/ProduccionV2/components/BloqueoCorrelativoTancadas/BloqueoCorrelativoTancadas";
import { conRelojProduccion, conRelojBodega } from "./common/components/App/ProduccionV2/components/RelojDesfase/RelojDesfase";

// Bodega de producción
import {
    IngresosBodega,
    RecepcionIngreso,

    HistorialSalidas,
    CreacionSalida,
    BoletaSalida as BoletaSalidaBodega,

    HistorialControlCalidad,
    CreacionControlCalidad,
    BoletaControlCalidad,

    InventarioBodega,
    CreacionCierre,
    DetalleCierre,
    ReajustePacas,
    PacasAlCorte,
} from "./common/components/App/ProdBodega";

// EVS
import {
    ListadoEVS,
    CreacionEVS,
} from "./common/components/App/EVS";

// Producto Terminado
import {
    ListadosPT,
    CreacionPT,
} from "./common/components/App/ProductoTerminado";

// Producciones
import {ProduccionesCrear, ProduccionesListar, ProduccionesVer} from "./common/components/App/ProduccionSolidos"
// Proveedores
import {ProveedoresList, CrearProveedor} from "./common/components/App/Proveedores"

import ConfiguracionEditar from "./common/components/App/Configuracion";
// Reportes
import {
    ReporteLiquidaciones, ReporteCostoFletes, ReporteRecepciones, ReporteRecepcionesAnual, ReporteDRCRecepciones, ReporteRecepcionesKgSecos, ReporteRecepcionesKgSecosLiquidados,
    ReporteProducciones, ReporteVersusDRC, ReporteLaboratorio, ReporteFluctuacionPrecios, ReporteExcendenteAmoniaco,
    ReporteLiquidacionesProveedores, BonificacionesClass, ReporteRecepcionesProveedores, ReporteUbicacionFincas, ReporteTrasladosMateria,
    ReporteKgSecosAnual, ReporteDRCAnual, ReporteMateriaPrimaAnual, ReporteMateriaPrimaMensual, ReporteLiquidacionSemanal,
    BitacoraListar,BitacoraDetalle, ReportePilaAlmacen, DetallePilaAlmacen, ReporteLabProveedores, ReporteNh3DrcProveedores, ReporteNh3VfaProveedores, ReporteAnualProveedores,
    LaboratoriosDRCClass
} from './common/components/App/Reportes';

// Anulación de recepciones
import { Anulacion } from "./common/components/App/Anulacion";

// Laboratoristas
import { LaboratoristasList, LaboratoristaCrear } from "./common/components/App/Laboratoristas";

// Clientes
import { ClientesTabs, ClienteCrear, CreacionConsumidorFinal } from "./common/components/App/Clientes";

// Despachos
import { DespachosList, DespachosCrear, despachoVerBoleta, DespachoEditar } from "./common/components/App/Despachos";

// Historico
import { HistoricoRecepciones, DetalleRecepcionHistorico, RecepcionHistoricoBoleta, HistoricoLiquidaciones, DetalleLiquidacionHistorico, LiquidacionHistoricoBoleta } from "./common/components/App/Historico"

//Canal
import { CanalList, CanalSalida, BoletaCanal } from "./common/components/App/Produccion/Canal";
import Catalogo_Proveedores from './common/components/App/Reportes/Catalogo_Proveedores';
import HistorialTanques from './common/components/App/Reportes/HistorialTanques';
import Canal_Reporte from './common/components/App/Reportes/Canal';

require('../../node_modules/font-awesome/css/font-awesome.css');
require('../../node_modules/bootstrap/dist/css/bootstrap.css');
require('../style/index.css');

/**
 * Al agregar una ruta, verificar cómo se manejaría en la función isItemSelected() del componente Sidebar.
 */
module.exports = (
    <div>
        <div className="container__content">
            <Switch>
                <Route exact path="/login" component={Login}/>
                <Route exact path="/registro" component={Registro}/>
                <Route exact path="/recuperar_pass" component={sendRecoverPassword}/>
                <Route exact path="/cambiar_pass/:token" component={PassRecover}/>
                <ProtectedRoute exact path="/" component={Home}/>
                <ProtectedRoute exact path="/page2" component={Examples}/>
                <ProtectedRoute exact path="/user-profile" component={Profile}/>
                <ProtectedRoute exact path="/grids" component={Grids}/>
                <ProtectedRoute exact path="/notifications" component={Notificaciones}/>
                <ProtectedRoute exact path="/tabs" component={ExampleTabs}/>

                {/*Usuarios*/}
                <ProtectedRoute exact path="/usuarios" component={UsuariosList}/>
                <ProtectedRoute exact path="/usuario/crear" component={CrearUsuario}/>
                <ProtectedRoute exact path="/usuario/:id/editar" component={CrearUsuario}/>
                {/*Bancos*/}
                <ProtectedRoute exact path="/bancos" component={BancosListar}/>
                <ProtectedRoute exact path="/banco/crear" component={BancoCrear}/>
                <ProtectedRoute exact path="/banco/:id/editar" component={BancoCrear}/>
                {/*EnvioNotificiaciones*/}
                <ProtectedRoute exact path="/notificaciones" component={EmailsListar}/>
                <ProtectedRoute exact path="/notificaciones/crear" component={EmailsCrear}/>
                <ProtectedRoute exact path="/notificaciones/:id/editar" component={EmailsCrear}/>
                {/*Propietarios*/}
                <ProtectedRoute exact path="/propietarios" component={PropietariosListar}/>
                <ProtectedRoute exact path="/propietario/crear" component={PropietarioCrear}/>
                <ProtectedRoute exact path="/propietario/:id/editar" component={PropietarioCrear}/>
                {/*Perfil finca*/}
                <ProtectedRoute exact path="/perfiles" component={PerfilesFincaList}/>
                <ProtectedRoute exact path="/perfil/crear" component={PerfilCrear}/>
                <ProtectedRoute exact path="/perfil/:id/editar" component={PerfilCrear}/>
                {/*Transportistas*/}
                <ProtectedRoute exact path="/transportistas" component={TransportistasList}/>
                <ProtectedRoute exact path="/transportista/crear" component={TransportistaSave}/>
                <ProtectedRoute exact path="/transportista/:id/editar" component={TransportistaSave}/>
                {/*Vehiculos*/}
                <ProtectedRoute exact path="/vehiculos" component={VehiculosListar}/>
                <ProtectedRoute exact path="/vehiculo/crear" component={VehiculoCrear}/>
                <ProtectedRoute exact path="/vehiculo/:id/editar" component={VehiculoCrear}/>
                {/*Tipos de vehiculo*/}
                <ProtectedRoute exact path="/tipos_vehiculo" component={TiposVehiculoListar}/>
                <ProtectedRoute exact path="/tipo_vehiculo/crear" component={TiposVehiculoCrear}/>
                <ProtectedRoute exact path="/tipo_vehiculo/:id/editar" component={TiposVehiculoCrear}/>
                {/*Pilotos*/}
                <ProtectedRoute exact path="/pilotos" component={PilotosListar}/>
                <ProtectedRoute exact path="/piloto/crear" component={PilotoCrear}/>
                <ProtectedRoute exact path="/piloto/:id/editar" component={PilotoCrear}/>
                {/* Tipos de Materia Prima */}
                <ProtectedRoute exact path="/tipos_materia_prima" component={TiposMateriaPrimaListar}/>
                <ProtectedRoute exact path="/tipo_materia_prima/crear" component={TipoMateriaPrimaCrear}/>
                <ProtectedRoute exact path="/tipo_materia_prima/:id/editar" component={TipoMateriaPrimaCrear}/>
                {/* Materia Pima */}
                <ProtectedRoute exact path="/materias_primas" component={MateriaPrimaListar}/>
                <ProtectedRoute exact path="/materia_prima/crear" component={MateriaPrimaCrear}/>
                <ProtectedRoute exact path="/materia_prima/:id/editar" component={MateriaPrimaCrear}/>
                {/* Tipos de pago */}
                <ProtectedRoute exact path="/tipos_pago" component={TiposPagoListar}/>
                <ProtectedRoute exact path="/tipo_pago/crear" component={TipoPagoCrear}/>
                <ProtectedRoute exact path="/tipo_pago/:id/editar" component={TipoPagoCrear}/>
                {/*Acopios*/}
                <ProtectedRoute exact path="/acopios" component={AcopiosList}/>
                <ProtectedRoute exact path="/acopio/crear" component={AcopioSave}/>
                <ProtectedRoute exact path="/acopio/:id/editar" component={AcopioSave}/>
                {/* Fincas */}
                <ProtectedRoute exact path="/fincas" component={FincasListar}/>
                <ProtectedRoute exact path="/finca/crear" component={FincaCrear}/>
                <ProtectedRoute exact path="/finca/:id/editar" component={FincaCrear}/>
                <ProtectedRoute exact path="/finca/:id/bitacora_fletes" component={FincaBitacoraFletes}/>
                <ProtectedRoute exact path="/finca/:id/" component={FincaVer}/>
                {/* Bodegas */}
                {/* <ProtectedRoute exact path="/bodegas" component={BodegasListar}/> */}
                <ProtectedRoute exact path="/bodegas" component={BodegasTabs}/>
                <ProtectedRoute exact path="/bodega/crear" component={BodegaCrear}/>
                <ProtectedRoute exact path="/bodega/:id/editar" component={BodegaCrear}/>
                <ProtectedRoute exact path="/bodega/:id/" component={BodegaVer}/>
                {/* Tanques */}
                <ProtectedRoute exact path="/tanques" component={TanquesListar}/>
                {/* Pilas */}
                <ProtectedRoute exact path="/pilas" component={PilasList}/>
                <ProtectedRoute exact path="/pila/:id" component={PilaVer}/>
                <ProtectedRoute exact path="/pila/:id/salida" component={PilaSalida}/>
                {/*Almacenes*/}
                <ProtectedRoute exact path="/almacenes" component={AlmacenesList}/>
                <ProtectedRoute exact path="/almacen/:id" component={AlmacenVer}/>
                <ProtectedRoute exact path="/almacen/:id/salida" component={CreacionTrasladoAlmacen}/>
                {/*Canal*/}
                <ProtectedRoute exact path="/canal" component={CanalList}/>
                <ProtectedRoute exact path="/canal/:id/salida" component={CanalSalida}/>
                <ProtectedRoute exact path="/canal/:id/boleta_salida" component={BoletaCanal} />
                {/* Ingresos */}
                <ProtectedRoute exact path="/ingresos" component={IngresosListar}/>
                <ProtectedRoute exact path="/ingreso/crear" component={IngresoCrear}/>
                <ProtectedRoute exact path="/ingreso/:id/editar" component={IngresoCrear}/>
                <ProtectedRoute exact path="/ingreso/:id/pesar" component={IngresoPesar}/>
                <ProtectedRoute exact path="/ingreso/:id/pesar/registrar" component={EditarPesoProducto}/>
                <ProtectedRoute exact path="/ingreso/:id/" component={IngresoVer}/>
                <ProtectedRoute exact path="/ingreso/:id/boleta_ingreso" component={IngresoVerBoleta}/>
                <ProtectedRoute exact path="/ingreso/:id/boleta_salida" component={BoletaSalida}/>

                <ProtectedRoute exact path="/ingreso/crear/contenedores" component={CrearRecepcionesClass}/>
                <ProtectedRoute exact path="/ingreso/ver/contenedores/:viaje_id" component={ResumenCreacionClass}/>


                {/* Laboratorio LATEX y validaciones */}
                <ProtectedRoute exact path="/laboratorio/analisis_latex" component={LaboratorioLatexListar}/>
                <ProtectedRoute exact path="/laboratorio/analisis_latex/:id/" component={AnalisisLatexVer}/>
                <ProtectedRoute exact path="/laboratorio/analisis_latex/:id/editar" component={LaboratorioLatexEditar}/>
                <ProtectedRoute exact path="/laboratorio/validar_drc_latex" component={PendientesLatexValidar}/>
                <ProtectedRoute exact path="/laboratorio/validar_drc_latex/:id/" component={AnalisisLatexVer}/>
                <ProtectedRoute exact path="/laboratorio/drc_validados_latex" component={HistoricoAnalisisLatex}/>
                <ProtectedRoute exact path="/laboratorio/drc_validados_latex/:id/" component={AnalisisLatexVer}/>
                {/* Laboratorio SOLIDO y validaciones */}
                <ProtectedRoute exact path="/laboratorio/analisis_solido" component={LaboratorioSolidoListar}/>
                <ProtectedRoute exact path="/laboratorio/analisis_solido/:id/" component={AnalisisSolidoVer}/>
                <ProtectedRoute exact path="/laboratorio/analisis_solido/:id/editar" component={LaboratorioSolidoEditar}/>
                <ProtectedRoute exact path="/laboratorio/validar_drc_solido" component={PendientesSolidoValidar}/>
                <ProtectedRoute exact path="/laboratorio/validar_drc_solido/:id/" component={AnalisisSolidoVer}/>
                <ProtectedRoute exact path="/laboratorio/drc_validados_solido" component={HistoricoAnalisisSolido}/>
                <ProtectedRoute exact path="/laboratorio/drc_validados_solido/:id/" component={AnalisisSolidoVer}/>
                {/*ANÁLISIS DE BODEGAS (LABORATORIO PARA BODEGAS)*/}
                <ProtectedRoute exact path="/laboratorio/analisis_pilas" component={AnalisisPilasListar}/>
                <ProtectedRoute exact path="/laboratorio/analisis_pilas/:id/" component={AnalisisPilasVer}/>
                <ProtectedRoute exact path="/laboratorio/analisis_pilas/:id/editar" component={AnalisisPilasEditar}/>
                <ProtectedRoute exact path="/laboratorio/validar_drc_pilas" component={AnalisisPilasPendienteValidacion}/>
                <ProtectedRoute exact path="/laboratorio/validar_drc_pilas/:id/" component={AnalisisPilasVer}/>
                <ProtectedRoute exact path="/laboratorio/drc_validados_pilas" component={AnalisisPilasHistorico}/>
                <ProtectedRoute exact path="/laboratorio/drc_validados_pilas/:id/" component={AnalisisPilasVer}/>
                {/* Configuración*/}
                <ProtectedRoute exact path="/configuracion" component={ConfiguracionEditar}/>
                {/* Liquidaciones */}
                <ProtectedRoute exact path="/liquidaciones" component={LiquidacionesListar}/>
                <ProtectedRoute exact path="/liquidacion/:id/generar" component={LiquidacionesCrear}/>
                <ProtectedRoute exact path="/liquidacion/:id/" component={LiquidacionesVer}/>
                <ProtectedRoute exact path="/liquidacion/:id/boleta_liquidacion" component={BoletaLiquidacion}/>
                {/* Compras */}
                <ProtectedRoute exact path="/compras" component={ComprasListar}/>
                <ProtectedRoute exact path="/compra/:id/generar" component={ComprasCrear}/>
                {/* Contaminantes */}
                <ProtectedRoute exact path="/contaminantes" component={ContaminantesListar}/>
                <ProtectedRoute exact path="/contaminante/crear" component={ContaminanteCrear}/>
                <ProtectedRoute exact path="/contaminante/:id/editar" component={ContaminanteCrear}/>
                {/* Traslados */}
                <ProtectedRoute exact path="/crear-traslado" component={CreacionTraslado} />
                <ProtectedRoute exact path="/traslados-envio" component={EnvioTraslados} />
                <ProtectedRoute exact path="/traslados-recepcion" component={RecepcionTraslados} />
                <ProtectedRoute exact path="/reporte-traslados" component={ReporteTraslados} />

                <ProtectedRoute exact path="/traslados/:id/recepcion" component={RecepcionTraslado}/>
                <ProtectedRoute exact path="/traslados/:id/seleccion-recepciones" component={SeleccionRecepciones}/>
                <ProtectedRoute exact path="/traslados/:id/edicion-recepciones/:materia_prima_id" component={SeleccionRecepciones}/>
                <ProtectedRoute exact path="/traslados/:id/edicion-recepciones" component={SeleccionRecepciones}/>
                <ProtectedRoute exact path="/traslados/:id/pesaje-traslado" component={PesajeTraslado}/>
                <ProtectedRoute exact path="/traslados/:id/ver-boleta" component={BoletaTraslado}/>

                {/* InventariosAlmacen */}
                <ProtectedRoute exact path="/inventarios-almacen/historico" component={HistoricoInventarios} />
                <ProtectedRoute exact path="/inventarios-almacen/almacenes/:id" component={AlmacenesInventario} />
                <ProtectedRoute exact path="/inventarios-almacen/gestion-almacen/:id" component={GestionAlmacen} />
                <ProtectedRoute exact path="/inventarios-almacen/ingresos-almacen/:id" component={IngresosAlmacen} />
                <ProtectedRoute exact path="/inventarios-almacen/inventario-inicial" component={InventarioInicial} />
                <ProtectedRoute exact path="/inventarios-almacen/reporte" component={ReporteInventarios} />
                <ProtectedRoute exact path="/inventarios-almacen/reporte/crear-cierre-mensual" component={CreacionCierreMensual} />
                <ProtectedRoute exact path="/inventarios-almacen/reporte/cierre-mensual/:id" component={DetalleCierreMensual} />
                <ProtectedRoute exact path="/inventarios-almacen/otros-acopios" component={InventarioOtrosAcopios} />
                <ProtectedRoute exact path="/inventarios-almacen/otros-acopios/ingresos/:id" component={IngresosAlmacen} />
                <ProtectedRoute exact path="/inventarios-almacen/otros-acopios/sobrante/:id" component={SobranteAlmacenConsulta} />

                {/* Laboratorio de producción */}
                <ProtectedRoute exact path="/laboratorio_produccion/pendientes_analisis" component={PendientesAnalisis} />
                <ProtectedRoute exact path="/laboratorio_produccion/analizar_drc/:id" component={AnalisisDRC} />
                <ProtectedRoute exact path="/laboratorio_produccion/pendientes_validacion" component={PendientesValidacion} />
                <ProtectedRoute exact path="/laboratorio_produccion/validar_drc/:id" component={ValidacionDRC} />
                <ProtectedRoute exact path="/laboratorio_produccion/historial" component={HistorialSolicitudes} />
                <ProtectedRoute exact path="/laboratorio_produccion/detalle/:id" component={DetalleDRC} />

                {/* Producción V2 */}
                <ProtectedRoute exact path="/produccion-v2/producciones" component={Producciones} />
                <ProtectedRoute exact path="/produccion-v2/crear-produccion" component={CreacionProduccion} />
                <ProtectedRoute exact path="/produccion-v2/editar-produccion/:id" component={EdicionProduccion} />
                <ProtectedRoute exact path="/produccion-v2/turnos-produccion" component={conRelojProduccion(conCorrelativoInicial(TurnosProduccion))} />
                <ProtectedRoute exact path="/produccion-v2/tancadas/:id" component={conRelojProduccion(conCorrelativoInicial(conCorrelativoTancadas(Tancadas)))} />
                <ProtectedRoute exact path="/produccion-v2/cargas-tancada/:id" component={conRelojProduccion(conCorrelativoInicial(conCorrelativoTancadas(CargasTancada)), { esFormulario: true })} />
                <ProtectedRoute exact path="/produccion-v2/detalle-tancadas/:id" component={Tancadas} />
                <ProtectedRoute exact path="/produccion-v2/tancadas-turno/:turno_id" component={TancadasTurno} />
                <ProtectedRoute exact path="/produccion-v2/produccion-reportada" component={conRelojProduccion(conCorrelativoInicial(conCorrelativoTancadas(ProduccionReportada)))} />
                <ProtectedRoute exact path="/produccion-v2/paletizaciones" component={conRelojProduccion(Paletizaciones)} />
                <ProtectedRoute exact path="/produccion-v2/crear-paletizacion/:id_paletizacion" component={conRelojProduccion(conCorrelativoInicial(conCorrelativoTancadas(CreacionPaletizacion)), { esFormulario: true })} />
                <ProtectedRoute exact path="/produccion-v2/detalle-paletizacion/:id_paletizacion" component={DetallePaletizacion} />
                <ProtectedRoute exact path="/produccion-v2/cierre-turno" component={conRelojProduccion(conCorrelativoInicial(conCorrelativoTancadas(CierreTurno)))} />
                <ProtectedRoute exact path="/produccion-v2/detalle-turno-finalizado/:id" component={DetalleTurnoFinalizado} />
                <ProtectedRoute exact path="/produccion-v2/miga-desecho" component={conCorrelativoInicial(conCorrelativoTancadas(MigaDesecho))} />
                <ProtectedRoute exact path="/produccion-v2/bultos-skim" component={conRelojProduccion(conCorrelativoInicial(conCorrelativoTancadas(BultosSkim)))} />
                <ProtectedRoute exact path="/produccion-v2/cierres-mensuales" component={CierresMensualesProduccion} />
                <ProtectedRoute exact path="/produccion-v2/cierres-mensuales/registrar-cierre" component={RegistroCierreMensualProduccion} />
                <ProtectedRoute exact path="/produccion-v2/cierres-mensuales/detalle-cierre/:id" component={DetalleCierreMensualProduccion} />
                <ProtectedRoute exact path="/produccion-v2/reportes" component={ReportesProduccion} />

                {/* EVS */}
                <ProtectedRoute exact path="/evs" component={ListadoEVS} />
                <ProtectedRoute exact path="/evs/crear-evs" component={CreacionEVS} />
                <ProtectedRoute exact path="/evs/:id/editar" component={CreacionEVS} />

                {/* Producción Bodega */}
                {/* Ingresos */}
                <ProtectedRoute exact path="/produccion-bodega/ingresos" component={conRelojProduccion(IngresosBodega)} />
                <ProtectedRoute exact path="/produccion-bodega/recepcion-ingreso/:id_paletizacion" component={conRelojProduccion(conCorrelativoInicial(RecepcionIngreso), { esFormulario: true })} />
                <ProtectedRoute exact path="/produccion-bodega/detalle-recepcion/:id_paletizacion" component={RecepcionIngreso} />

                {/* Salidas */}
                <ProtectedRoute exact path="/produccion-bodega/salidas" component={conRelojBodega(HistorialSalidas)} />
                <ProtectedRoute exact path="/produccion-bodega/crear-salida" component={conRelojBodega(conCorrelativoInicial(CreacionSalida), { esFormulario: true })} />
                <ProtectedRoute exact path="/produccion-bodega/salidas/:id/ver-boleta" component={BoletaSalidaBodega} />

                {/* Control de Calidad */}
                <ProtectedRoute exact path="/produccion-bodega/control-calidad" component={conRelojBodega(HistorialControlCalidad)} />
                <ProtectedRoute exact path="/produccion-bodega/crear-control-calidad" component={conRelojBodega(conCorrelativoInicial(CreacionControlCalidad), { esFormulario: true })} />
                <ProtectedRoute exact path="/produccion-bodega/control-calidad/:id/ver-boleta" component={BoletaControlCalidad} />

                {/* Inventario de bodega */}
                <ProtectedRoute exact path="/produccion-bodega/inventario" component={InventarioBodega} />
                <ProtectedRoute exact path="/produccion-bodega/inventario/crear-cierre" component={conCorrelativoInicial(CreacionCierre)} />
                <ProtectedRoute exact path="/produccion-bodega/inventario/reajuste/:tipo/:producto_id/:es_conforme_bodega" component={conCorrelativoInicial(ReajustePacas)} />
                <ProtectedRoute exact path="/produccion-bodega/inventario/cierre/:id" component={DetalleCierre} />
                <ProtectedRoute exact path="/produccion-bodega/inventario/cierre/:id/pacas/:producto_id/:es_conforme_bodega" component={PacasAlCorte} />
                <ProtectedRoute exact path="/produccion-bodega/inventario/pacas-al-corte/:producto_id/:es_conforme_bodega/:fecha_corte" component={PacasAlCorte} />

                {/* Producto Terminado */}
                <ProtectedRoute exact path="/producto-terminado" component={ListadosPT} />
                <ProtectedRoute exact path="/producto-terminado/crear" component={CreacionPT} />
                <ProtectedRoute exact path="/producto-terminado/:id/editar" component={CreacionPT} />

                {/* Producciones */}
                <ProtectedRoute exact path="/producciones" component={ProduccionesListar}/>
                <ProtectedRoute exact path="/produccion/crear" component={ProduccionesCrear}/>
                <ProtectedRoute exact path="/produccion/:id/editar" component={ProduccionesCrear}/>
                <ProtectedRoute exact path="/produccion/:id/" component={ProduccionesVer}/>

                {/*Proveedores*/}
                <ProtectedRoute exact path="/Proveedores" component={ProveedoresList}/>
                <ProtectedRoute exact path="/proveedor/crear" component={CrearProveedor}/>
                <ProtectedRoute exact path="/proveedor/:id/editar" component={CrearProveedor}/>

                {/* Reportes */}
                <ProtectedRoute exact path="/reporte/ingresos" component={ReporteRecepciones}/>
                <ProtectedRoute exact path="/reporte/anual_ingresos" component={ReporteRecepcionesAnual}/>
                <ProtectedRoute exact path="/reporte/drc_ingresos" component={ReporteDRCRecepciones}/>
                <ProtectedRoute exact path="/reporte/liquidaciones" component={ReporteLiquidaciones}/>
                <ProtectedRoute exact path="/reporte/costo_fletes" component={ReporteCostoFletes}/>
                <ProtectedRoute exact path="/reporte/kg_secos_ingresos" component={ReporteRecepcionesKgSecos}/>
                <ProtectedRoute exact path="/reporte/kg_secos_ingresos_liquidados" component={ReporteRecepcionesKgSecosLiquidados}/>
                <ProtectedRoute exact path="/reporte/producciones" component={ReporteProducciones}/>
                <ProtectedRoute exact path="/reporte/drc_lab_vs_drc_prod" component={ReporteVersusDRC}/>
                <ProtectedRoute exact path="/reporte/laboratorio" component={ReporteLaboratorio}/>
                {/* <ProtectedRoute exact path="/reporte/fluctuacion_precios" component={ReporteFluctuacionPrecios}/> */}
                <ProtectedRoute exact path="/reporte/excedente_amoniaco" component={ReporteExcendenteAmoniaco}/>
                <ProtectedRoute exact path="/reporte/ubicacion_geografica_fincas" component={ReporteUbicacionFincas}/>
                <ProtectedRoute exact path="/reporte/traslados_materia" component={ReporteTrasladosMateria}/>
                <ProtectedRoute exact path="/reporte/anual_proveedores" component={ReporteAnualProveedores}/>
                {/* Reportes especificos adicionales */}
                <ProtectedRoute exact path="/reporte/kg_secos_anual" component={ReporteKgSecosAnual}/>
                <ProtectedRoute exact path="/reporte/drc_anual" component={ReporteDRCAnual}/>
                <ProtectedRoute exact path="/reporte/liquidacion_semanal" component={ReporteLiquidacionSemanal}/>
                <ProtectedRoute exact path="/reporte/reporte_materia_prima_anual" component={ReporteMateriaPrimaAnual}/>
                <ProtectedRoute exact path="/reporte/reporte_materia_prima_mensual" component={ReporteMateriaPrimaMensual}/>
                <ProtectedRoute exact path="/reporte/reporte_pila_almacen" component={ReportePilaAlmacen}/>
                <ProtectedRoute exact path="/reporte/reporte_pila_almacen/:id" component={DetallePilaAlmacen}/>
                {/* HistorialTanques */}
                <ProtectedRoute exact path="/reporte/historial_tanques" component={HistorialTanques}/>
                {/* Bitacora */}
                <ProtectedRoute exact path="/reporte/canal" component={Canal_Reporte}/>
                <ProtectedRoute exact path="/reporte/bitacora" component={BitacoraListar}/>
                <ProtectedRoute exact path="/reporte/bitacora/:id" component={BitacoraDetalle}/>
                <ProtectedRoute exact path="/reporte/catalogo_proveedores" component={Catalogo_Proveedores}/>
                {/* Laboratorios DRC */}
                <ProtectedRoute exact path="/reporte/laboratorios_drc" component={LaboratoriosDRCClass}/>
                <ProtectedRoute exact path="/reporte/laboratorios_drc_latex/:id/" component={AnalisisLatexVer}/>
                <ProtectedRoute exact path="/reporte/laboratorios_drc_solidos/:id/" component={AnalisisSolidoVer}/>

                {/* Reportes de proveedores */}
                <ProtectedRoute exact path="/reporte/liquidaciones_proveedores" component={ReporteLiquidacionesProveedores}/>
                <ProtectedRoute exact path="/reporte/ingresos_proveedores" component={ReporteRecepcionesProveedores}/>
                <ProtectedRoute exact path="/reporte/bonificaciones" component={BonificacionesClass}/>
                <ProtectedRoute exact path="/laboratorio_prov/lab_proveedores" component={ReporteLabProveedores}/>
                <ProtectedRoute exact path="/laboratorio_prov/nh3_drc" component={ReporteNh3DrcProveedores}/>
                <ProtectedRoute exact path="/laboratorio_prov/nh3_vfa" component={ReporteNh3VfaProveedores}/>

                {/* Roles */}
                <ProtectedRoute exact path="/roles" component={RolesListar}/>
                <ProtectedRoute exact path="/rol/crear" component={RolesCrear}/>
                <ProtectedRoute exact path="/rol/:id/editar" component={RolesCrear}/>

                {/* Anulacion de Recepción */}
                <ProtectedRoute exact path="/anulacion" component={Anulacion}/>

                {/* Laboratoristas */}
                <ProtectedRoute exact path="/laboratoristas" component={LaboratoristasList}/>
                <ProtectedRoute exact path="/laboratoristas/crear" component={LaboratoristaCrear}/>
                <ProtectedRoute exact path="/laboratoristas/:id/editar" component={LaboratoristaCrear}/>

                {/* Clientes */}
                <ProtectedRoute exact path="/clientes" component={ClientesTabs}/>
                <ProtectedRoute exact path="/clientes/:id/editar" component={ClienteCrear}/>
                <ProtectedRoute exact path="/clientes/crear" component={ClienteCrear}/>
                <ProtectedRoute exact path="/clientes/consumidores-finales/crear" component={CreacionConsumidorFinal}/>
                <ProtectedRoute exact path="/clientes/consumidores-finales/:id/editar" component={CreacionConsumidorFinal}/>

                {/* Despachos */}
                <ProtectedRoute exact path="/despacho" component={DespachosList}/>
                <ProtectedRoute exact path="/despacho/:id/editar" component={DespachoEditar}/>
                <ProtectedRoute exact path="/despacho/:id/" component={DespachosCrear}/>
                <ProtectedRoute exact path="/despacho/:id/boleta" component={despachoVerBoleta}/>
                <ProtectedRoute exact path="/despacho/crear" component={DespachosCrear}/>

                {/* Histórico */}
                <ProtectedRoute exact path="/historico/recepciones" component={HistoricoRecepciones}/>
                <ProtectedRoute exact path="/historico/recepciones/:id" component={DetalleRecepcionHistorico}/>
                <ProtectedRoute exact path="/historico/recepciones/:id/boleta" component={RecepcionHistoricoBoleta}/>
                <ProtectedRoute exact path="/historico/liquidaciones" component={HistoricoLiquidaciones}/>
                <ProtectedRoute exact path="/historico/liquidaciones/:id" component={DetalleLiquidacionHistorico}/>
                <ProtectedRoute exact path="/historico/liquidaciones/:id/boleta" component={LiquidacionHistoricoBoleta}/>

                <Route component={NotFound}/>
            </Switch>
        </div>
        <NotificationContainer/>
    </div>
);
